import { motion } from "framer-motion";

// Static wrapper — always visible (no scroll-hide). Prevents blank sections.
export const Reveal = ({ children, className = "", as = "div" }) => {
  const Tag = as;
  return <Tag className={className}>{children}</Tag>;
};

// Static text — always visible, bolder/beautiful headings handled via className.
export const WordsReveal = ({ text, className = "" }) => (
  <span className={className}>{text}</span>
);

// Masked line reveal — used only for the hero on-load animation.
export const MaskLines = ({ lines = [], className = "", lineClass = "", delay = 0, stagger = 0.12 }) => (
  <span className={className} aria-label={lines.join(" ")}>
    {lines.map((line, i) => (
      <span key={i} className="mask-line" aria-hidden="true">
        <motion.span
          className={`block ${lineClass}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.9, delay: delay + i * stagger, ease: [0.22, 1, 0.36, 1] }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
